import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Toll } from '@classes/toll';
// import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import * as _moment from 'moment';
import { EnvConfigurationService } from './env-configuration.service';
const moment = _moment;

@Injectable({
  providedIn: 'root'
})
export class TollService {
  environment = this.envConfigurationService.environment;

  private basePath = this.environment.apiUrl + '/toll';

  constructor(
    private http: HttpClient,
    public envConfigurationService: EnvConfigurationService
  ) { }

  getTolls(starDate?: Date, endDate?: Date): Observable<Array<Toll>> {
    let params: any = {};
    if (starDate) {
      params.starDate = moment(starDate).format("YYYY-MM-DD");
    }
    if (endDate) {
      params.endDate = moment(endDate).format("YYYY-MM-DD");
    }
    return this.http.get<Array<Toll>>(this.basePath, {
      params: params
    });
  }

  createOrUpdateToll(toll?: Toll): Observable<Toll> {
    if (toll && toll.date instanceof Date) {
      toll.date = moment(toll?.date).format('YYYY-MM-DDTHH:mm')
    }
    if (toll?.id) {
      //update
      const url = `${this.basePath}/${toll?.id}`;
      return this.http.patch<any>(url,
        toll).pipe(map(m => {
          return m
        }));
    } else {
      //create

      return this.http.post<any>(this.basePath,
        toll
      ).pipe(map(m => {
        return m
      }));
    }
  }

  deleteToll(tollId: string): Observable<any> {
    const baseUrl = this.basePath;
    const url = `${baseUrl}/${tollId}`;
    return this.http.delete(url);
  }
}
